import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { Deal, DealIndexVendor, DealSearchCondition } from "~/models/Deal";
import { convertQueryStringUrl } from "~/utils/DealSearchConditionUtils";

const paths = {
	index: "/vendors/deals",
	show: "/vendors/deals/:id"
};
type TIndex = (
	query: DealSearchCondition
) => SwrReturnType<Pageable<DealIndexVendor>>;
type TShow = (id: number | null) => SwrReturnType<Deal>;
type ReturnType = {
	index: TIndex;
	show: TShow;
};

export const useDeals = (): ReturnType => {
	const index: TIndex = (query: DealSearchCondition) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<Pageable<DealIndexVendor>>(
			convertQueryStringUrl(paths.index, query)
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	const show: TShow = (id: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<Deal>(
			id === null ? null : paths.show.replace(":id", String(id))
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index, show };
};
